// The unsupported-format message lists these in this order.
export const ALLOWED_FILE_TYPES = [
  '.pdf',
  '.doc',
  '.docx',
  '.rtf',
  '.eml',
  '.msg',
  '.xls',
  '.xlsx',
  '.csv',
  '.html',
  '.htm',
  '.txt',
  '.md',
  '.png',
  '.jpg',
  '.jpeg',
  '.tif',
  '.tiff',
];
export const ALLOWED_MIME_TYPES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/rtf',
  'text/rtf',
  'application/pdf',
  'message/rfc822',
  'application/vnd.ms-outlook',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
  'text/html',
  'text/plain',
  'text/markdown',
  'image/png',
  'image/jpeg',
  'image/tiff',
];

export const CHAT_UPLOAD_ACCEPT = ALLOWED_FILE_TYPES.join(',');

export const MAX_FILES_PER_QUERY = 50;
